var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({staticClass:"spinner",attrs:{"height":_vm.size,"width":_vm.size,"viewBox":"0 0 50 50"}},_vm.$listeners),[_c('circle',{attrs:{"cx":"50%","cy":"50%","r":"40%","fill":"none","stroke-width":"10%","stroke":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }